// extracted by mini-css-extract-plugin
export default {"MainViews":"MainViews_MainViews__oPcgJ"};